module.exports = __webpack_public_path__ + "static/media/preview2-large.6fc08943.jpg";